import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UnsubscribePayload, UserPreferencesPayload } from '../utils/common.interface';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private http: HttpClient
  ) { }

  getNotifications(userId: string, page?: number, limit?: number) {
    let url = `${environment.API_BASE_URL_V3}/list-notification?id=${userId}`;
    if (page) {
      url += `&page=${page}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    return this.http.get(url);
  }

  readNotification(data: any) {
    return this.http.patch(`${environment.API_BASE_URL_V3}/read-notification`, data);
  }

  deleteNotification(notificationId: any) {
    return this.http.get(`${environment.API_BASE_URL}/user/delete-notification?id=${notificationId}`);
  }

  getEmailPreferencesByUserId(): Observable<any> {
    return this.http.get(`${environment.API_BASE_URL_V3}/mail-preference`);
  }

  updateEmailPreferences(payload: UserPreferencesPayload): Observable<any> {
    return this.http.patch(`${environment.API_BASE_URL_V3}/mail-preference`, payload);
  }

  /** Public (no login): details for the unsubscribe link token from an email footer */
  getUnsubscribeDetails(token: string): Observable<any> {
    return this.http.get(`${environment.API_BASE_URL_V3}/unsubscribe`, { params: { token } });
  }

  /** Public (no login): switches off the email type named in the token, with the user's reason */
  unsubscribe(payload: UnsubscribePayload): Observable<any> {
    return this.http.post(`${environment.API_BASE_URL_V3}/unsubscribe`, payload);
  }
}
